<div [ngClass]="'ui-treetable ui-widget'" [ngStyle]="style" [class]="styleClass">
  <div class="ui-treetable-header ui-widget-header" *ngIf="header">
    <ng-content select="p-header"></ng-content>
  </div>
  <div class="ui-treetable-tablewrapper">
    <table class="ui-widget-content table table-bordered">
      <thead>
        <tr class="ui-state-default">
          <th #headerCell 
          *ngFor="let col of columns" 
          [ngStyle]="col.style" 
          [class]="col.styleClass" 
          [ngClass]="'ui-state-default ui-unselectable-text'">
            <span class="ui-column-title" *ngIf="!col.headerTemplate">{{col.header}}</span>
            <span class="ui-column-title" *ngIf="col.headerTemplate">
              <p-columnHeaderTemplateLoader [column]="col"></p-columnHeaderTemplateLoader>
            </span>
          </th>
        </tr>
      </thead>
      <tfoot *ngIf="hasFooter()">
        <tr>
          <td 
          *ngFor="let col of columns" 
          [ngStyle]="col.style" 
          [class]="col.styleClass" 
          [ngClass]="{'ui-state-default':true}">
            <span class="ui-column-footer" *ngIf="!col.footerTemplate">{{col.footer}}</span>
            <span class="ui-column-footer" *ngIf="col.footerTemplate">
              <p-columnFooterTemplateLoader [column]="col"></p-columnFooterTemplateLoader>
            </span>
          </td>
        </tr>
      </tfoot>
      <tbody class="p-0 m-0" 
        pTreeRow 
        *ngFor="let node of value" 
        [node]="node" 
        [level]="0" 
        [labelExpand]="labelExpand"
        [labelCollapse]="labelCollapse"></tbody>
    </table>
  </div>
  <div class="ui-treetable-footer ui-widget-header" *ngIf="footer">
    <ng-content select="p-footer"></ng-content>
  </div>
</div>
